var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/pagination-macro.j2"] = require( "macros/pagination-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-paging.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n\n";
env.getTemplate("macros/pagination-macro.j2", false, "category/templates/category-paging.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("buildPagination")) {
var t_4 = t_1.buildPagination;
} else {
cb(new Error("cannot import 'buildPagination'")); return;
}
context.setVariable("buildPagination", t_4);
output += "\n\n";
var t_5;
t_5 = (runtime.contextOrFrameLookup(context, frame, "categoryPagingLocation")?runtime.contextOrFrameLookup(context, frame, "categoryPagingLocation"):"");
frame.set("categoryPagingLocation", t_5, true);
if(frame.topLevel) {
context.setVariable("categoryPagingLocation", t_5);
}
if(frame.topLevel) {
context.addExport("categoryPagingLocation", t_5);
}
output += "\n\n<div class=\"dom-paging\">\n    ";
output += runtime.suppressValue((lineno = 8, colno = 20, runtime.callWrap(t_4, "buildPagination", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"context"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"pageOptions")),"pageCount"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"pageOptions")),"currentPage")),"page"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"pageOptions")),"nextPage"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"pageOptions")),"prevPage"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug"),runtime.contextOrFrameLookup(context, frame, "categoryPagingLocation")])), env.opts.autoescape);
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-paging.j2"] , dependencies)